import GoLiveCheckCard from './maintenance/GoLiveCheckCard';
import DuplicateNumbersCard from './maintenance/DuplicateNumbersCard';
import ContactStatesCard from './maintenance/ContactStatesCard';
import JobDiscountsCard from './maintenance/JobDiscountsCard';
import CommissionsCard from './maintenance/CommissionsCard';
import OrphanedUsersCard from './maintenance/OrphanedUsersCard';
import DuplicateJobsCard from './maintenance/DuplicateJobsCard';
import RepairLeadsCard from './maintenance/RepairLeadsCard';
import JobTypeNumbersCard from './maintenance/JobTypeNumbersCard';

// GO-LIVE #3 + #2: single screen admin/superadmin uses instead of the
// browser console to check whether the system is ready to operate, and to
// scan/apply the data-repair endpoints that already existed in
// admin_maintenance.py.
export default function MaintenanceTab({ users = [] }) {
  return (
    <div className="space-y-4" data-testid="maintenance-tab">
      <GoLiveCheckCard />
      <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide pt-2">Data maintenance checks</p>
      <DuplicateNumbersCard />
      <ContactStatesCard />
      <JobDiscountsCard />
      <CommissionsCard />
      <OrphanedUsersCard users={users} />
      <DuplicateJobsCard />
      <RepairLeadsCard />
      <JobTypeNumbersCard />
    </div>
  );
}
